var _defs, _g, _g2, _g3, _g4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowMeter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42259",
    "data-name": "Group 42259",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.494,
    height: 32.235,
    viewBox: "0 0 49.494 32.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70661",
    "data-name": "Path 70661",
    d: "M-8462.034,6050.34l8.206,9.157-5.483,8.329-1.033,4.029-5.558,1.584-6.939-.7-.415-2.128,1.555-10.565Z",
    transform: "translate(8473.257 -6050.34)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70664",
    "data-name": "Path 70664",
    d: "M-8462.034,6050.34l8.206,9.157-5.483,8.329-1.033,4.029-5.558,1.584-6.939-.7-.415-2.128,1.555-10.565Z",
    transform: "translate(8473.257 -6050.34)",
    fill: "#f8b018"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70667",
    "data-name": "Path 70667",
    d: "M-8465.051,6050.34l-8.206,9.157,5.483,8.329,1.033,4.029,5.558,1.584,6.938-.7.416-2.128-1.555-10.565Z",
    transform: "translate(8473.257 -6050.34)",
    fill: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42256",
    "data-name": "Group 42256",
    transform: "translate(8.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M25.58,14.81a12.505,12.505,0,0,0-17.709,0L0,6.939a23.626,23.626,0,0,1,33.45,0l-.775,2.167-5.829,5.829Z",
    fill: "#dbdbdb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_72",
    "data-name": "Mask Group 72",
    transform: "translate(0 3.733)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42255",
    "data-name": "Group 42255",
    transform: "translate(1.032 -3.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70652",
    "data-name": "Path 70652",
    d: "M7.032,165.758A23.565,23.565,0,0,0,0,182.433a1.389,1.389,0,0,0,1.392,1.388H9.837a1.389,1.389,0,0,0,1.392-1.388A12.432,12.432,0,0,1,14.9,173.6l-.857-3.63-2.331-2.324Z",
    transform: "translate(0 -158.84)",
    fill: "#ef2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70654",
    "data-name": "Path 70654",
    d: "M75.771,97.9l7.871,7.847a12.509,12.509,0,0,1,8.855-3.662v-11.1A23.627,23.627,0,0,0,75.771,97.9Z",
    transform: "translate(-68.739 -90.987)",
    fill: "#ef2e2e"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_73",
    "data-name": "Mask Group 73",
    transform: "translate(0 3.733)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42257",
    "data-name": "Group 42257",
    transform: "translate(1.032 -3.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70662",
    "data-name": "Path 70662",
    d: "M7.032,165.758A23.565,23.565,0,0,0,0,182.433a1.389,1.389,0,0,0,1.392,1.388H9.837a1.389,1.389,0,0,0,1.392-1.388A12.432,12.432,0,0,1,14.9,173.6l-.857-3.63-2.331-2.324Z",
    transform: "translate(0 -158.84)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70663",
    "data-name": "Path 70663",
    d: "M75.771,97.9l7.871,7.847a12.509,12.509,0,0,1,8.855-3.662v-11.1A23.627,23.627,0,0,0,75.771,97.9Z",
    transform: "translate(-68.739 -90.987)",
    fill: "#f8b018"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_74",
    "data-name": "Mask Group 74",
    transform: "translate(30.066 3.733)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M15.313,24.981a1.389,1.389,0,0,1-1.391-1.389,12.429,12.429,0,0,0-3.674-8.827A12.507,12.507,0,0,0,1.393,11.1C1.393,10.628,0,10.166,0,9.715V1.329C0,.9,1.393.454,1.393,0A23.625,23.625,0,0,1,18.117,6.918v0l0,0A23.566,23.566,0,0,1,25.15,23.593a1.389,1.389,0,0,1-1.391,1.389Z",
    transform: "translate(-6.782 -3.722)",
    fill: "#f2f2f2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M5.579,0A5.511,5.511,0,0,0,1.643,1.646,5.492,5.492,0,0,0,.7,8.245,5.522,5.522,0,0,0,2.59,10.278c4.371,2.783,7.684,4.9,12.056,7.711a1.38,1.38,0,0,0,1.671-.139,1.476,1.476,0,0,0,.163-.168,1.413,1.413,0,0,0,.2-1.474c-2.2-4.707-3.873-8.269-6.071-12.975A5.811,5.811,0,0,0,8.577.865a5.668,5.668,0,0,0-2.154-.8A5.493,5.493,0,0,0,5.579,0Z",
    transform: "matrix(-0.921, 0.391, -0.391, -0.921, 32.295, 25.005)",
    fill: "#0b3454",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowMeter);
export default __webpack_public_path__ + "static/media/yellow-meter.26ef744c9d3ceecdf28a9a5af4a70714.svg";
export { ForwardRef as ReactComponent };